import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffBasesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      base_id: null,
      date_start: '',
      staff_bases: [],
      bases_list: [],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);

    this.locale = getLocale();
  }
  
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_bases)) {
      this.setState({
        staff_bases: newProps.staff_bases,
        bases_list: newProps.bases_list,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     base_id: this.state.base_id,
  //     date_start: this.state.date_start,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_bases: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  
  // // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa base?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/base/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_bases: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa base?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/base/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_bases: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/bases/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_bases: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/bases/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_bases: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tituloBases}</h3>
  <hr/>
  {(this.state.staff_bases === null || typeof this.state.staff_bases === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.nenhumaBaseCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.DataInicial}</th>
          <th className="text-center">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Aase}</th>
          <th className="text-center">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Atatus}</th>
          {/* <th className="col-md-1 text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_bases).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_bases[k].date_start_str}</td>
              <td className="text-center">{self.state.staff_bases[k].base}</td>
              <td className="text-center">{(self.state.staff_bases[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Arquivado}</span>}</td>
              {/* <td className="text-center">
                {(self.state.staff_bases[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_bases[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_bases[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Adicionar base</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Base:</label>
        <Select
          className="form-field-name"
          name="base_id"
          value={this.state.base_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'base_id')}
          options={this.state.bases_list}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar base</button>
  </form> */}
</div>
    );
  }
}

export default StaffBasesTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffBasesTab.js